import { configureStore } from "@reduxjs/toolkit";
import layoutReducer from "features/layout/layoutSlice";
import regionReducer from 'features/region/regionSlice';


export const store = configureStore({
    reducer: {
        layout: layoutReducer,
        region: regionReducer,
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;